import React from "react";
import { Modal } from "react-bootstrap";

import Button from "../components/controls/Button";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export default function modalPreviewImage(props) {
  return (
    <Modal show={props.isOpen} centered size="lg">
      <Modal.Body>
        <div className="ut-all-center ut-flex-column">
          <img src={props.previewImage} style={{ height: 500, objectFit: "cover" }} alt="random" />
          <div className="ut-d-flex ut-w-100 ut-align-items-center ut-justify-content-center">
            <Button onClick={props.onToggle} size="sm" color="light" buttonStyle="filled" name="Close" rightIcon={faTimes} />
            <Button onClick={props.onSend} size="sm" color="secondary" textColor="white" buttonStyle="filled" name="Send" rightIcon={faPaperPlane} />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
